import React, { useState} from 'react';
import { MediaProvider } from './context/MediaContext';
import './App.css';
import About from './pages/About/About';
import Home from './pages/Home/Home';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Services from './pages/Services/Services';
import Voices from './pages/Jobs/Jobs';
import Blog from './pages/Blog/Blog';
import CourseCatalog from './components/CourseCatalog';
import ContactPage from './pages/Contact/ContactPage';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import translations from './jsons/translations.json';
import ScrollToTop from './functions/ScrollToTop';


function App() {

  const [language, setLanguage] = useState(() => {
    return localStorage.getItem('language') || 'es';
  });

  const toggleLanguage = () => {
    const newLanguage = language === 'es' ? 'en' : 'es';
    setLanguage(newLanguage);
    localStorage.setItem('language', newLanguage);
  };


 

  return (
    <div className="App" style={{ whiteSpace: 'pre-line' }}>
      <MediaProvider>
      <Router>
      <ScrollToTop/>
        <Routes>
        <Route path='/' element={<Home language={language} toggleLanguage={toggleLanguage} translations={translations} />} />
          <Route path='/about' element={<About language={language} toggleLanguage={toggleLanguage} translations={translations} />} />
          <Route path='/services' element={<Services language={language} toggleLanguage={toggleLanguage} translations={translations} />} />
          <Route path='/jobs' element={<Voices language={language} toggleLanguage={toggleLanguage} translations={translations} />} />
          <Route path='/blog' element={<Blog language={language} toggleLanguage={toggleLanguage} translations={translations} />} />
          <Route path='/contact' element={<ContactPage language={language} toggleLanguage={toggleLanguage} translations={translations} />} />
  <Route path="/cursos" element={<CourseCatalog/>}/>
        </Routes>
      </Router>
      </MediaProvider>
    </div>
  );
}

export default App;
